import { render, staticRenderFns } from "./bag-type.vue?vue&type=template&id=6561b954&scoped=true&lang=pug&"
import script from "./bag-type.vue?vue&type=script&lang=ts&"
export * from "./bag-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561b954",
  null
  
)

export default component.exports